<template>
    <div class="fl-check">
        <div class="container">
            <p>
                <b @click="showDescr = !showDescr" style="cursor: pointer; font-size: 16px; border-bottom: 2px dashed #333; font-weight: 500;">Описание</b>
                <i class="uk-icon-question-circle" style="vertical-align: top; font-size: 0.8rem; padding-left: 2px;"></i>
            </p>
            <p v-if="showDescr" style="font-size: 16px; font-weight: 400; margin: 20px 0; max-width: 960px; padding: 20px; background: #eee; border: 1px solid lightgray; border-radius: 5px;">
                <b>Среднее время проверки составляет от 0.5 до 3 минут.</b>
                <br>
                Сформированный отчёт будет загружен в виде файла в вашем браузере.
                <br>
                <br>
                Позволяет оперативно обнаружить негативные факторы в отношении ФЛ (вхождение в «черные списки», банкротство, большие суммы налоговых задолженностей или исполнительных производств и прочие), а также другую важную информацию на стадии до начала сотрудничества, а также дать основания для прекращения текущего сотрудничества, если в процессе будут выявлены новые появившиеся негативные факторы.
                <br>
                Позволяет выявить возможность сотрудничества с ФЛ в качестве ИП или самозанятого и использовать выгоды соответствующих режимов налогообложения.
                <br>
                <br>
                <b>Типовые примеры использования:</b>
                <ul style="list-style-type: disc; width: 100%;">
                    <li>проверка потенциальных контрагентов-ФЛ</li>
                    <li>проверка кандидатов на работу</li>
                    <li>периодическая проверка отдельных контрагентов-ФЛ (например, раз в месяц/квартал/год)</li>
                    <li>периодическая проверка сотрудников (например, раз в месяц/квартал/год)</li>
                </ul>
            </p>
            <div class="rasporka" style="padding-top: 5px">
                <ul class="fl-check__list">
                    <h3 class="fl-check__list__subheader" style="font-size: 24px;"><b>Проверяемые реестры:</b></h3>
                    <li :class="getClass('passports')">Проверка паспорта</li>
                    <li :class="getClass('check_inn')">Проверка ИНН</li>
                    <li :class="getClass('fed_rozysk')">Реестр федерального розыска МВД РФ</li>
                    <li :class="getClass('terrorists')">Реестр террористов/экстремистов</li>
                    <li :class="getClass('fsin')">Реестр розыска ФСИН</li>
                    <li :class="getClass('fssp_fl_rozysk_yk')">Реестр розыска ФССП (совершенные преступления)</li> 
                    <li :class="getClass('fssp_fl_rozysk_ip')">Реестр розыска ФССП (по исполнительным производствам)</li>
                    <li :class="getClass('fssp_fl_ip')">Банк данных исполнительных производств ФССП</li>
                    <li :class="getClass('bankrupt')">Реестр банкротств физических лиц</li>
                    <li :class="getClass('dismissed_person')">Реестр лиц, уволенных в связи с утратой доверия</li>
                    <li :class="getClass('nedoimki')">Налоговая задолженность ФЛ</li>
                    <li :class="getClass('pledge')">Реестр залогов движимого имущества</li>
                    <li :class="getClass('disq_person')"> Реестр дисквалифицированных лиц ФНС РОССИИ</li>
                    <li :class="getClass('restrict_on_part_ul')">Реестр ограничений участия в ЮЛ ФНС РОССИИ</li>
                    <li :class="getClass('check_ip')">Наличие статуса ИП</li>
                    <li :class="getClass('self_employed')">Наличие статуса самозанятого</li>
                    <li :class="getClass('mass_person')">Реестр массовых руководителей</li>
                    <li :class="getClass('mass_person')">Реестр массовых учредителей</li>
                    <li :class="getClass('affil')">Аффилированные структуры</li>
                </ul>
                <div class="form">
                    <div class="form__container rasporka">
                        <div class="form__box" style="float:left">
                            <div class="form__header">Фамилия<span>&#42;</span></div>
                            <input
                                class="surname"
                                type="text"
                                placeholder="Фамилия"
                                v-model="surname"
                                @input="onInput($event,'surname', /[^а-яa-z-]/gi)"
                            />
                        </div>
                        <div class="form__box" style="float:left">
                            <div class="form__header">Имя<span>&#42;</span></div>
                            <input
                                class="name"
                                type="text"
                                placeholder="Имя"
                                v-model="name"
                                @input="onInput($event,'name', /[^а-яa-z-]/gi)"
                            />
                        </div>
                        <div class="form__box" style="float:left">
                            <div class="form__header">Отчество<span>&#42;</span></div>
                            <input
                                class="patronymic"
                                type="text"
                                placeholder="Отчество"
                                v-model="patronymic"
                                @input="onInput($event,'patronymic', /[^а-яa-z-]/gi)"
                            />
                        </div>
                        <div class="form__box" style="float:right">
                            <div class="form__header">Дата рождения</div>
                            <input
                                type="text"
                                v-model="birthday"
                                class="birthday"
                                placeholder="31.12.2020"
                                @input="onInput($event, 'birthday')"
                                maxlength="10"
                            />
                        </div>
                    </div>
                    <div class="form__container rasporka" style=" margin-top: 15px">
                        <div class="form__box" style="float:left">
                            <div class="form__header">ИНН ФЛ</div>
                            <input
                                class="inn"
                                @input="onInput($event, 'inn', /[^0-9]/g)"
                                v-model="inn"
                                placeholder="ИНН ФЛ"
                                type="text"
                                :maxlength="12"
                            />
                        </div>
                        <div class="form__box" style="float:right">
                            <div class="form__header">Серия и номер паспорта</div>
                            <input
                                class="serial"
                                @input="onInput($event, 'serial', /[^0-9]/g)"
                                v-model="serial"
                                placeholder="Серия"
                                type="text"
                                :maxlength="4"
                            />
                            <input
                                @input="onInput($event, 'number', /[^0-9]/g)"
                                class="number"
                                placeholder="Номер"
                                v-model="number"
                                type="text"
                                :maxlength="6"
                            />
                        </div>
                    </div>
                    <div class="form__container rasporka" style=" margin-top: 20px">
                        <label for="approve">
                            <input type="checkbox" name="approve" v-model="hasApproval" id="approve">
                            <span>Настоящим подтверждаю наличие письменного или иным образом зафиксированного согласия физического лица на обработку его персональных данных.</span>
                        </label>
                    </div>
                    <div class="form__container rasporka" style="margin-top: 20px; text-align: right;">
                        <button @click="clearForm" class="btn">Очистить</button>
                        <button @click="sendForm" class="btn blue" :class="{'inactive': getInapproval()}" :disabled="getInapproval()">Поиск</button>
                        <!-- <btn @click="sendForm" blue style="width: 107px; box-shadow: 0 0 0;">Поиск</btn> -->
                    </div>
                    <p style="font-size: 14px; text-align: right;" v-if="limits">Использовано запросов: {{limits.used_total}}<span v-if="limits.total"> из {{limits.total}}</span></p>
                    <p style="float: right"><span id="asterics">&#42;</span> - поля обязательные к заполнению</p>
                </div>
            </div>
        </div>
        <div v-if="loading" style="text-align: center">
            <span style="color: #444; font-size:12px">Данные подготавливаются. Приблизительное время ожидания не более 5 минут.</span>
            <shestirenka/>
        </div>
        <fl-history ref="history" />
        <flCheckPdf v-if="upload" :dateCheck="dateCheck" :list="list" :upload="upload" :name="name" :surname="surname" :patronymic="patronymic" :birthday="birthday" :serial="serial" :number="number" :inn="inn ? inn : checkedInn" :inputInn="inn" />
    </div>
</template>

<script>
import axios from 'axios'
import flCheckPdf from '@/components/rosseti/visitorFLCheckCombined/flCheck/flCheckPdf.vue'
import flHistory from '@/components/rosseti/visitorFLCheckCombined/flCheck/flHistory.vue'
import shestirenka from '@/components/ui/shestirenkaLoader.vue'
import btn from '@/components/ui/button.vue.js'

export default {
    components: {
        flCheckPdf,
        shestirenka,
        flHistory,
        btn
    },
    data() {
        return {
            dateCheck: Date.now(),
            surname: '',
            showDescr: false,
            name: '',
            patronymic: '',
            inn: '',
            birthday: '',
            serial: '',
            number: '',
            avaibleList: [],
            inputTimeout: null,
            stringCount: 0,
            hasApproval: false,
            allowedList: [],
            maxLengthList: {
                birthday : 10,
                inn : 12,
                serial : 4,
                number : 6
            },
            modules: [
                "passports",
                "check_inn",
                "check_ip",
                "fl_affil",
                "bankrupt",
                "disq_person",
                "fssp_fl_ip",
                "fssp_fl_rozysk_ip",
                "fssp_fl_rozysk_yk",
                "fed_rozysk",
                "terrorists",
                "nedoimki",
                "fsin"
            ]
        }
    },
    mounted() {
        if(!window .auth) {
            window.location.replace('/')
        }
    },
    methods: {
        getData(
            name = this.name,
            surname = this.surname,
            patronymic = this.patronymic,
            birthday = this.birthday,
            serial = this.serial,
            number = this.number,
            inn = this.inn
        ) {
            this.$store.dispatch('flCheck/getData', {name, surname, patronymic, birthday, serial, number, inn})
        },
        adminRequest(value){
            this.$refs.history.setCheckbox(value)
        },
        getAllowed(data) {
            if(this.allowedList.indexOf(data) == -1 && this[data] && this[data].length > 0 && !this.maxLengthList.hasOwnProperty(data)) {
                this.allowedList = [...this.allowedList, data]
            } else if(this.maxLengthList.hasOwnProperty(data) && this[data].length == this.maxLengthList[data]) {
                this.allowedList = [...this.allowedList, data]
            } else if(this.allowedList.indexOf(data) > -1 && this[data].length == 0 && !this.maxLengthList.hasOwnProperty(data)) {
                this.allowedList = this.allowedList.filter(item => item != data)
            } else if(this.maxLengthList.hasOwnProperty(data) && this[data].length != this.maxLengthList[data]) {
                this.allowedList = this.allowedList.filter(item => item != data)
            }
            this.$store.dispatch('flCheck/getAllowed', this.allowedList)
        },
        getClass(e) {
            return {'black' : this.exactlyMarkers.indexOf(e) != -1}
        },
        dateFormat(evt){
            let inputString = evt.target.value
            let result = true
            this.birthday = evt.target.value.replace(/[^0-9.]/g, '')
            if (inputString.length < this.stringCount) {
                this.stringCount = inputString.length
                result = false	
            }
            if (inputString.length === 2 && result) {
                evt.target.value += '.'
                this.stringCount = inputString.length + 1
                this.birthday = evt.target.value	
            }
            if (inputString.length === 5 && result) {
                evt.target.value += '.'
                this.stringCount = inputString.length + 1
                this.birthday = evt.target.value
            }
            result = true
        },
        sendForm() {
            this.getData()
        },
        getInapproval() {
            return !(this.hasApproval && this.name && this.surname && this.patronymic)
        },
        clearForm() {
            this.name = '',
            this.surname = '', 
            this.patronymic = '',
            this.serial = '',
            this.number = '',
            this.birthday = '',
            this.inn = ''
            this.allowedList = []
            this.getAllowed('')
        },
        onInput(evt, type, reg) {
            if(type == 'birthday') {
                this.dateFormat(evt)
                clearTimeout(this.inputTimeout)

                this.inputTimeout = setTimeout(() => {
                    this.getAllowed(type)
                }, 300)

            } else {
                this[type] = evt.target.value.replace(reg, '')
                clearTimeout(this.inputTimeout)
                this.inputTimeout = setTimeout(() => {
                    this.getAllowed(type)
                }, 300)
            }
        }
    },
    computed: {
        list() { return this.$store.state.flCheck?.list },
        loading() { return this.$store.state.flCheck?.loading },
        upload() { return this.$store.state.flCheck?.upload },
        checkedInn() { return this.$store.state.flCheck?.checkedInn },
        exactlyMarkers() { return this.$store.state.flCheck?.exactlyMarkers },
        limits() {
            if(this.$store.state.user?.limits?.length) {
                return this.$store.state.user?.limits?.filter(e => e.id == 108)[0]
            }
        }
    }
}
</script>

<style lang="sass" scoped>
@import "styles/global-variables.sass"

.btn
    font-family: Gotham Pro, sans-serif
    display: inline-block
    vertical-align: top
    width: 110px
    height: 34px
    text-align: center
    line-height: 34px
    font-weight: 400
    font-size: 14px
    border: 0
    border-radius: 5px
    cursor: pointer
    color: #333
    background-color: transparent
    &:active
        color: #484747
        background-color: #a7baf9

.blue
    color: #fff
    background-color: #4771f3
    margin-right: 10px

.black
    color: black !important
    font-weight: 600
    list-style-type: disc !important

.fa-user
    margin-top: 5px
    font-size: 20px

.fl-check
    padding-top: 20px
    font-family: Gotham Pro, sans-serif
    &__header-folder
        display: flex
        justify-content: center
    &__header
        text-align: center
        margin-bottom: 50px
    &__list,
    .form
        display: inline-block
        vertical-align: top
    &__list
        +grid-size(5)
        list-style-type: none
        float: left
        padding: 0
        &__subheader
            margin-bottom: 20px
            font-size: 20px
        li
            color: rgb(153, 153, 153)
            font-size: 14px
            list-style-type: circle
    .form
        float: right
        @include grid-size(7)
        &__box
            display: inline-block
            vertical-align: top
            margin: 0 10px 0 0
            .name
                margin: 0
            .birthday
                width: 110px
            .inn
                width: 345px
            .serial
                width: 130px
            input
                min-height: 30px
                border-radius: 3px
                padding: 4px 8px
                border: 1px solid #b8b8b8
                box-shadow: none
                text-align: left
        &__header
            margin: 2px auto
            font-weight: 400
            font-size: 14px
        &__container
            label[for="approve"]
                font-size: 14px
                cursor: pointer
                input,
                span
                    display: inline-block
                    vertical-align: top
                span
                    width: 95%
            &_lower
                margin-top: 20px
.inactive
    opacity: 0.5
    cursor: not-allowed
@media (max-width: 1440px)
    .form
        &__box
            input
                width: 160px
            .name
                width: 165px
            .birthday
                width: 150px !important
            .inn
                width: 345px !important
            .serial
                width: 150px !important
                margin-right: 10px
@media (max-width: 1280px)
    .form
        &__box
            float: none !important
            display: block !important
            input
                width: 150px !important
            // .birthday
            //     width: 90px
            .inn
                width: 272px !important
            .serial
                width: 90px !important
            .serial
                width: 90px !important
            .number
                width: 170px !important
</style>